var Vendd = (function (Vendd) {
    'use strict';

    Vendd.AllOrdersHistory = (function (allOrdersHistory) {

        allOrdersHistory.Messages = (function (Messages) {

            // GetOrderItems
            Messages.GetOrderItems = function (orderId) {
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.AllOrdersHistory.Messages.GetOrderItems', orderId);
            };
            Messages.GetOrderItems.className = 'Vendd.AllOrdersHistory.Messages.GetOrderItems';

            Messages.GetOrderItemsSuccess = function (response) {
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.AllOrdersHistory.Messages.GetOrderItemsSuccess', response);
            };
            Messages.GetOrderItemsSuccess.className = 'Vendd.AllOrdersHistory.Messages.GetOrderItemsSuccess';

            Messages.GetOrderItemsFailure = function (response) {
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.AllOrdersHistory.Messages.GetOrderItemsFailure', response);
            };
            Messages.GetOrderItemsFailure.className = 'Vendd.AllOrdersHistory.Messages.GetOrderItemsFailure';

            Messages.OrderItemsRendered = function (itemsCount) {
                Vendd.MessageBus.VenddMessage.call(
                    this,
                    'Vendd.AllOrdersHistory.Messages.OrderItemsRendered',
                    { itemsCount: itemsCount }
                );
            };
            Messages.OrderItemsRendered.className = 'Vendd.AllOrdersHistory.Messages.OrderItemsRendered';

            // AddSkusListToCart
            Messages.AddSkusListToCart = function (data) {
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.AllOrdersHistory.Messages.AddSkusListToCart', data);
            };
            Messages.AddSkusListToCart.className = 'Vendd.AllOrdersHistory.Messages.AddSkusListToCart';


            return Messages;

        })(allOrdersHistory.Messages || {});

        return allOrdersHistory;

    })(Vendd.AllOrdersHistory || {});

    return Vendd;

})(Vendd || {});
